export default __webpack_public_path__ + "static/media/mclogo.8f60aafb.jpg";